<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Edit Notification
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col md="12">
          <v-form>
            <v-container style="padding:0px !important">
              <v-textarea
                filled
                :error-messages="messages.content"
                v-model="content"
                label="Notification"
              >
                <template slot="append-outer">
                  <v-tooltip left>
                   <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                   </template>
                   <span>Edit noitification content</span>
                  </v-tooltip>
                </template>
              </v-textarea>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn v-if="!loading" color="grey300" class="cancel-button"  @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="primary" class="ml-4 add-course-button"  @click="updateNotificationContent">Save</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import notificationAPI from "@/api/notification.js";
export default {
  name: "CreateTest",
  components: {},
  props: {
    type: {
      type: Number,
      default: null
    },
    course_id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      notification: {},
      messages: {},
      content:"",
      loading: false,
      successMessage: "Notification has been updated.",
      errorMessage: "Oops something went wrong",
    };
  },
  computed: {},
  mounted() {
    if(this.course_id=="" || this.course_id==null)
      this.getNotification(this.type);
    else
      this.getNotificationWithCourseId(this.type,this.course_id);
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    getNotification(type) {
        notificationAPI.getNotification(this.type).then(resp => {
        if(resp.data.data.length>0) {
          switch(type) {
            case 1:
              this.content = resp.data.data[0].course_assign;
              break;
            case 2:
              this.content = resp.data.data[0].playlist_assign;
              break;
            case 3:
              this.content = resp.data.data[0].deadline_set;
              break;
            case 4:
              this.content = resp.data.data[0].deadline_changed;
              break;
            case 5:
              this.content = resp.data.data[0].missed_deadline;
              break;
            case 6:
              this.content = resp.data.data[0].deadline_before;
              break;
            case 7:
              this.content = resp.data.data[0].idle_after;
              break;
            case 8:
              this.content = resp.data.data[0].external_deadline_before;
              break;
            case 9:
              this.content = resp.data.data[0].course_status_changed;
              break;
            case 10:
              this.content = resp.data.data[0].course_completion;
              break;
          }

        }
      });
    },
    getNotificationWithCourseId(type,course_id) {
      notificationAPI.getNotificationWithCourseId(this.type,this.course_id).then(resp => {
        if(resp.data.data.length>0) {
          switch(type) {
            case 1:
              this.content = resp.data.data[0].course_assign;
              break;
            case 2:
              this.content = resp.data.data[0].playlist_assign;
              break;
            case 3:
              this.content = resp.data.data[0].deadline_set;
              break;
            case 4:
              this.content = resp.data.data[0].deadline_changed;
              break;
            case 5:
              this.content = resp.data.data[0].missed_deadline;
              break;
            case 6:
              this.content = resp.data.data[0].deadline_before;
              break;
            case 7:
              this.content = resp.data.data[0].idle_after;
              break;
            case 8:
              this.content = resp.data.data[0].external_deadline_before;
              break;
            case 9:
              this.content = resp.data.data[0].course_status_changed;
              break;
            case 10:
              this.content = resp.data.data[0].course_completion;
              break;
          }

        }
      });
    },
    updateNotificationContent() {
      //this.loading = true;
        notificationAPI.addUpdateNotificationContent(this.content,this.type,this.course_id)
          .then(() => {
            this.closePanel();
            EventBus.$emit("NOTIFICATION_CONTENT_UPDATED", this.params);
            this.$snotify.success(this.successMessage);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          })
          .catch(err => {
            this.valid = false;
            this.$snotify.error(this.errorMessage);
            this.messages = this.$gf.errorResponse(err);
            this.loading = false;
            setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
          });
    },
  }
};
</script>